import { Map } from 'immutable';

import Campaign from 'entities/campaign/model';

export const cleanDuplicateCampaign = (campaign: Campaign): Omit<Campaign, 'id'> | null => {
  if (!campaign) {
    return null;
  }

  let cleanedCampaign = Map<keyof Campaign, any>(campaign);

  cleanedCampaign = cleanedCampaign.delete('id');
  cleanedCampaign = cleanedCampaign.delete('submitter');

  // @NOTE-EV: Handling fields that should not be exposed to the FE but might still exist
  // @ts-expect-error these fields should not be exposed in the FE & are not part of the model
  cleanedCampaign = cleanedCampaign.delete('projectStats');
  // @ts-expect-error these fields should not be exposed in the FE & are not part of the model
  cleanedCampaign = cleanedCampaign.delete('projectedStats');

  cleanedCampaign = cleanedCampaign.set('startingAt', '');
  cleanedCampaign = cleanedCampaign.set('endingAt', '');
  cleanedCampaign = cleanedCampaign.set('editors', []);
  cleanedCampaign = cleanedCampaign.set('optedInCompanies', []);

  return cleanedCampaign.toObject() as Omit<Campaign, 'id'>;
};
